import { createStore } from 'vuex'
export default createStore({
  state: {
    menu_id: '', // menu_id
  },
  getters: {
  },
  mutations: {
    // 保存menu_id
    saveMenuId(state, data) {
      state.menu_id = data;
    },
  },
  actions: {

  },
})